<template>
	<div class="StockCountStores">
		<el-card class="box-card">
			<el-row :gutter="30">
				<el-col :xs="24" :sm="12" :md="24" :lg="24" :xl="24">
					<div class="header-section">
						<div>
							<div style="color: #e29d5a; font-weight: 600;">Stock Count</div>
							<div class="text-xs" style="margin-top: 10px;">
								{{ todaysDate | formatDate }}
							</div>
						</div>

						<div style="display:flex;">
							<div style="display: flex;" class="mr-5">
								<label class="btn p-3">
									Upload Stock Csv
									<input
										id="stockCount"
										name="File Upload"
										accept=".csv"
										type="file"
										@change="getCsvFile($event, 'stockCount')"
									/>
								</label>
							</div>
							 <div>
								<a href="https://nymbleup-public.s3.ap-south-1.amazonaws.com/templates/Stock_expiry_test.csv">
								<BaseButton
									class="custom-input"
									buttonclass="btn p-3 text-sm"
								>
									Csv Template
								</BaseButton>
								</a>
							</div>
							<!-- <BaseButton buttonclass="btn p-3 text-xs">
								<a href="https://nymbleup-public.s3.ap-south-1.amazonaws.com/templates/Stock_expiry_test.csv" download></a>
							</BaseButton> -->
						</div>
					</div>
				</el-col>
				<el-col
					:xs="24"
					:sm="12"
					:md="6"
					:lg="6"
					v-if="loggedInUserData.access_level !== 'outlet'"
					:xl="6"
					class="mt-4"
				>
				<div  class="input-box box-250">
					<label class="input-label">Select Outlet</label>
					<div class="mt-1">
						<el-select
							v-model="selectedOutletId"
							filterable
							default-first-option
							placeholder="Select Outlet"
							:clearable="true"
							style="width: 100%; text-transform: capitalize;"
							@change="getStockCountForOutlet"
						>
							<el-option
								v-for="(outlet, outletIndex) in outlets"
								:key="outletIndex"
								:value="outlet.id"
								:label="outlet.name"
								style="text-transform: capitalize;"
							>
							</el-option>
						</el-select>
					</div>

				</div>
				</el-col>
			</el-row>
		</el-card>
		<el-card v-if="stockCount.length" class="box-card mt-5">
			<div class="mt-5">
				<simplebar class="simplebar">
					<table class="tableMain">
						<thead>
							<tr>
								<th style="max-width: 100px;">
									Batch
								</th>
								<th style="width: 250px;">
									Item Name
								</th>
								<th colspan="2">
									<p class="main-heading-border-bottom">System Count</p>
								</th>
								<th colspan="2">
									<p class="main-heading-border-bottom">Actual Count</p>
								</th>
								<th colspan="2">
									<p class="main-heading-border-bottom">Variance</p>
								</th>
								<th>
									<div class="heading-bottom-margin">
										Reason
									</div>
								</th>
								<th>
									<div class="heading-bottom-margin">
										Expiry Date
									</div>
								</th>
							</tr>
							<tr>
								<th style="width: 100px;">&nbsp;</th>
								<th style="width: 250px;">&nbsp;</th>
								<th style="width: 100px;">Pack Qty</th>
								<th style="width: 100px;">Loose Qty</th>
								<th style="width: 120px;">Pack Qty</th>
								<th style="width: 120px;">Loose Qty</th>
								<th style="width: 100px;">Pack Qty</th>
								<th style="width: 100px;">Loose Qty</th>
								<th style="width: 200px;">&nbsp;</th>
								<th style="width: 150px;">&nbsp;</th>
							</tr>
						</thead>
						<tbody
							v-for="(stock, stockCountIndex) in stockCount"
							:key="stockCountIndex"
						>
							<!-- <tr>
								<td colspan="10" class="font-semibold" style="text-align: left;" @click="stock.toggleCategory = !stock.toggleCategory">
									<div style="display: flex; align-items: center; height: 20px;">
										Category {{ stockCountIndex }}
										<i class="el-icon-circle-plus-outline cursor-pointer font-semibold ml-1" style="font-size: 15px;" v-if="!stock.toggleCategory"></i>
										<i class="el-icon-remove-outline cursor-pointer font-semibold ml-1"
										style="font-size: 15px;" v-if="stock.toggleCategory"></i>
									</div>
								</td>
							</tr> -->
							<tr style="padding: 5px 0;">
								<td style="width: 100px; text-transform: capitalize;">
									{{ stock.code }}
								</td>
								<td
									style="width: 250px; text-transform: capitalize;"
									class="font-semibold"
								>
									{{ stock.article_info.name }}
								</td>
								<!-- <td style="width: 250px; text-transform: capitalize;" class="font-semibold" :style="{color: new Date() > new Date(stock.expiry_date).setHours(0, 0, 0, 0) ? '#d60918' : '#000'}">
									{{ stock.article_info.name }}
								</td> -->
								<td style="width: 100px;">
									{{ stock.quantity }}
								</td>
								<td style="width: 100px;">
									{{ stock.loose_quantity }} {{ stock.base_unit }}
								</td>
								<td style="width: 200px;" class="number-input">
									<el-input-number
										v-model="stock.actualPackQty"
										style="width: 180px; font-size: 20px; font-weight: bold;"
									/>
								</td>
								<td style="width: 200px;" class="number-input">
									<el-input-number
										v-model="stock.actualLooseQty"
										style="width: 180px; font-size: 20px; font-weight: bold;"
									/>
								</td>
								<td style="width: 100px;">
									<!-- {{ variancePackQty(stock.quantity, stock.actualPackQty) }} -->
									<span class="text-red">{{
										variancePackQty(stock.quantity, stock.actualPackQty) < 0
											? variancePackQty(stock.quantity, stock.actualPackQty)
											: ""
									}}</span>

									<span>
										{{
											variancePackQty(stock.quantity, stock.actualPackQty) >= 0
												? variancePackQty(stock.quantity, stock.actualPackQty)
												: ""
										}}
									</span>
								</td>
								<td style="width: 100px;">
									<div
										style="display: flex; align-items: center; justify-content: center;"
									>
										<span class="text-red">{{
											varianceLooseQty(
												stock.loose_quantity,
												stock.actualLooseQty
											) < 0
												? varianceLooseQty(
														stock.loose_quantity,
														stock.actualLooseQty
												  )
												: ""
										}}</span>

										<span>
											{{
												varianceLooseQty(
													stock.loose_quantity,
													stock.actualLooseQty
												) >= 0
													? varianceLooseQty(
															stock.loose_quantity,
															stock.actualLooseQty
													  )
													: ""
											}}
										</span>
										<span
											v-if="
												varianceLooseQty(
													stock.loose_quantity,
													stock.actualLooseQty
												) > 0
											"
											style="font-size: 18px; color: #00d028"
											class="ml-2 mb-1"
										></span>
									</div>
								</td>
								<td style="width: 200px;">
									<el-select
										v-model="stock.reason"
										style="min-width: 100%;"
										size="medium"
										placeholder="Select reason"
									>
										<el-option
											v-for="(reason, reasonIndex) in reasons"
											:key="reasonIndex"
											:value="reason.id"
											:label="reason.name"
											style="text-transform: capitalize;"
										/>
									</el-select>
								</td>
								<td
									style="width: 150px;"
									:style="{
										color:
											new Date() >
											new Date(stock.expiry_date).setHours(0, 0, 0, 0)
												? '#d60918'
												: '#000'
									}"
								>
									{{ new Date(stock.expiry_date).toLocaleDateString() }}
								</td>
								<!-- <td colspan="10" style="padding: 0;">
									<table style="width: 100%; margin: 0; border: none;">
										<tbody
											v-for="(stock, stockCountIndex) in stockCount"
											:key="stockCountIndex"
										>
											<tr>
											</tr>
										</tbody>

									</table>
								</td> -->
							</tr>
						</tbody>
					</table>
				</simplebar>
				<div>
					<div class="flex justify-end items-center p-2 pr-4">
						<BaseButton
							:disabled="!stockCount.length"
							class="mr-5"
							buttonclass="btn py-1.5 px-4 text-sm"
							@click="saveStockCount"
						>
							Save Count
						</BaseButton>
						<div>
							<el-pagination
								background
								:current-page.sync="pageInfo.currentPage"
								:page-sizes="[5, 10, 15]"
								:page-size.sync="pageInfo.pageSize"
								layout="sizes, prev, pager, next"
								:total="pageInfo.totalCount"
								@size-change="handlePageInfoChange"
								@current-change="handlePageInfoChange"
							/>
						</div>
					</div>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import { UploadCsv } from "../../../../../mixins/processCsvFunctions/uploadCsv.mixin";
import moment from "moment";
import CommonService from "./../../../../services/commonService";
import InventoryService from "../../../../services/inventoryService";
import LaboutPlanningService from "../../../../services/labourPalnningService";
import { async, resolve } from "q";
import axios from "axios";
import { CommonMixin } from "../../../../../mixins/common.mixin";
export default {
	name: "StockCountStores",
	components: {
		simplebar
	},
	filters: {
		formatDate(date) {
			if (date) {
				var date = new Date(date);

				let options = {
					weekday: "long",
					year: "numeric",
					month: "long",
					day: "numeric"
				};

				return `${new Date(date).toLocaleString("en-us", options)}`;
			}
		}
	},
	mixins: [UploadCsv, CommonMixin],
	data() {
		return {
			selectedOutletId: "",
			outlets: [],
			loggedInUserData: {},
			stockCount: [],
			pageInfo: {
				currentPage: 1,
				totalCount: 0,
				pageSize: 10,
				search: ""
			},

			reasons: [
				{
					name: "Expired",
					id: "expired"
				},
				{
					name: "Bottle Broken",
					id: "bottle broken"
				},
				{
					name: "Customer Return",
					id: "customer return"
				},
				{
					name: "Damaged Product",
					id: "damaged product"
				},
				{
					name: "Item Missing",
					id: "item missing"
				}
			],
			reason: "",
			expiryDate: "",
			expiryDateQty: "",
			num: 2
		};
	},
	computed: {
		todaysDate() {
			return moment().format("YYYY-MM-DD");
		},
		variancePackQty() {
			return (quantity, actualPackQty) => {
				return (actualPackQty - quantity || 0).toFixed(3);
			};
		},
		varianceLooseQty() {
			return (looseQuantity, actualLooseQuantity) => {
				// return Math.abs(actualLooseQuantity - looseQuantity);
				return actualLooseQuantity - looseQuantity || 0;
			};
		}
	},
	created() {
		// this.getLoggedinUserData();
		axios
			.all([this.getLoggedinUserData(), this.getOutlets()])
			.then(
				axios.spread(async (loggedInUserData, outlets) => {
					this.loggedInUserData = loggedInUserData;
					this.outlets = outlets;
					// this.stockCount;
					if (loggedInUserData.access_level === "outlet") {
						this.selectedOutletId = loggedInUserData.access_outlet;
						this.stockCount = await this.getStockCount(
							loggedInUserData.access_outlet,
							this.todaysDate,
							this.pageInfo
						).then(data => data.results);
						for (var i in this.stockCount) {
							this.$set(
								this.stockCount[i],
								"actualPackQty",
								this.stockCount[i].quantity
							);
							this.$set(
								this.stockCount[i],
								"actualLooseQty",
								this.stockCount[i].loose_quantity
							);
							this.$set(this.stockCount[i], "toggleCategory", false);
						}
					} else {
						for (let i in this.outlets) {
							if (this.outlets[i].name == "atria") {
								this.selectedOutletId = this.outlets[i].id;
							}
						}
						this.stockCount = await this.getStockCount(
							this.selectedOutletId,
							this.todaysDate,
							this.pageInfo
						).then(data => data.results);
						for (var i in this.stockCount) {
							this.$set(
								this.stockCount[i],
								"actualPackQty",
								this.stockCount[i].quantity
							);
							this.$set(
								this.stockCount[i],
								"actualLooseQty",
								this.stockCount[i].loose_quantity
							);
							this.$set(this.stockCount[i], "toggleCategory", false);
						}
					}
					// this.stockCount = stockCount.then(response => {
					// 	console.log("response of stock count in created", response);
					// 	// return JSON.parse(response.data).results;
					// });
				})
			)
			.then(outlets => {});
	},
	methods: {
		paginate() {
			this.getStockCountForOutlet(this.selectedOutletId);
			// return async pageInfo => {
			// 	this.stockCount = await this.getStockCount(
			// 		this.selectedOutletId,
			// 		this.todaysDate,
			// 		pageInfo
			// 	).then(data => data.results);
			// 	for (var i in this.stockCount) {
			// 		this.$set(
			// 			this.stockCount[i],
			// 			"actualPackQty",
			// 			this.stockCount[i].quantity
			// 		);
			// 		this.$set(
			// 			this.stockCount[i],
			// 			"actualLooseQty",
			// 			this.stockCount[i].loose_quantity
			// 		);
			// 		this.$set(this.stockCount[i], "toggleCategory", false);
			// 	}
			// };
		},
		saveStockCount() {
			try {
				InventoryService.saveStockCount({
					outletId: this.selectedOutletId,
					date: this.todaysDate,
					params: this.stockCount.map(stock => {
						return {
							batch: stock.id,
							article: stock.article,
							old_quantity: stock.quantity,
							old_loose_quantity: stock.loose_quantity,
							quantity: stock.actualPackQty || stock.quantity,
							loose_quantity: stock.actualLooseQty || stock.loose_quantity,
							reason: "other" // backend to make some changes.
						};
					})
				}).then(response => {
					console.log("response in saveStockCount", response);
					if (response.status === 201) {
						this.$notify.success({
							title: "Success",
							message: "Success"
						});
					}
					if (!this.stockCount.length) {
						this.$notify.warning({
							title: "Warning",
							message: "No Data Found !"
						});
					}
				});
			} catch (err) {
				console.log(err);
				if (err.response.status !== 201) {
					this.$notify.error({
						title: "Fail",
						message: "Something Went Wrong"
					});
				}
			}
		},
		async getStockCountForOutlet(outletId) {
			if (outletId) {
				this.stockCount = await this.getStockCount(
					outletId,
					this.todaysDate,
					this.pageInfo
				).then(data => data.results);

				// let params = {
				// 	basics: "category",
				// 	id_list: []
				// };

				// called get category name api

				// console.log('cateGoryNameMappings', cateGoryNameMappings);
				// console.log('this.stockCount', this.stockCount);

				// for(var i=0; i<this.stockCount.length; i++){
				// 	params.id_list.push(this.stockCount[i].id)
				// 	// let filterd = cateGoryNameMappings.filter((stock,index) =>{
				// 		// 	console.log(this.stockCount[i].id == stock.id)
				// 	// 	stock.id == this.stockCount[i].id
				// 	// })
				// }
				// let cateGoryNameMappings = await this.getCateGoryNames(params);
				// console.log('filterd', cateGoryNameMappings);

				for (var i in this.stockCount) {
					this.$set(
						this.stockCount[i],
						"actualPackQty",
						this.stockCount[i].quantity
					);
					this.$set(
						this.stockCount[i],
						"actualLooseQty",
						this.stockCount[i].loose_quantity
					);
					this.$set(this.stockCount[i], "toggleCategory", false);
				}
			}
		},
		async getCateGoryNames(params) {
			try {
				return (
					InventoryService.nameMapping(params)
						// return LaboutPlanningService.getAllCategory()
						.then(response => {
							let data = JSON.parse(response.data);
							// console.log(data.results)
							return data;
						})
				);
			} catch (err) {
				console.log(err);
			}
		},
		async getLoggedinUserData() {
			try {
				var loggedInUserData = await CommonService.getLoggedinUserData().then(
					data => resolve(data)
				);
			} catch (err) {
				console.log(err);
			}
			return loggedInUserData;
		},
		async getOutlets() {
			var outlets = await CommonService.getOutlets().then(response => {
				if (response.status === 200) return JSON.parse(response.data);
			});
			return outlets;
		},
		async getStockCount(outletId, date, pageInfo) {
			try {
				var stockCount = InventoryService.getStockCount({
					outletId,
					date,
					pageInfo: pageInfo
				}).then(response => {
					let data = JSON.parse(response.data);
					if (!data.results.length) {
						this.$notify({
							title: "Fail",
							message: "No data found",
							type: "warning"
						});
					}
					this.pageInfo.totalCount = data.count;
					// data.results.forEach(stock => {
					// 	stock["actualPackQty"] = 0;
					// 	stock["actualLooseQty"] = 0;
					// 	stock["reason"] = "";
					// 	// return stock;
					// });
					return JSON.parse(response.data);
					console.log("response in getStockCount");
				});
			} catch (err) {
				console.log(err);
			}
			return stockCount;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./StockCountStores.scss";
</style>

<style>
.StockCountStores .Baseinput input {
	padding: 0.75rem !important;
	height: auto !important;
}
.tableMain .number-input .el-input__inner {
	font-weight: bolder;
	font-size: 16px;
}
.tableMain .number-input .el-input-number__decrease,
.el-input-number__increase {
	width: 60px;
}
</style>
<style lang="scss">
.el-input__inner {
	  text-transform: capitalize;
}
.el-select__tags {
	.el-select__input:focus {
		outline: none;
		border: none;
	}
}
// .el-input-number__decrease, .el-input-number__increase{
//   background-color: #e29d5a;
//   color: #fff;
//   border: none;
// }
.StockCountStores {
	.number-input {
		.el-input__inner {
			border: none;
		}
		.el-input-number__decrease {
			background: #dddddd 0% 0% no-repeat padding-box;
			// background: #ff5353 0% 0% no-repeat padding-box;
			border: 1px solid #f1f9ff;
			border-radius: 5px;
			// color: white;
			font-size: 18px;
			font-weight: bold;
		}
		.el-input-number__increase {
			// color: white;
			// background: #25b57e 0% 0% no-repeat padding-box;
			background: #dddddd 0% 0% no-repeat padding-box;
			border: 1px solid #f1f9ff;
			border-radius: 5px;
			font-size: 18px;
			font-weight: bold;
		}
	}
}
</style>
